var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12740_18063)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0742 9.05751C11.0742 6.91207 12.8134 5.17285 14.9589 5.17285H30.1618C32.3072 5.17285 34.0464 6.91207 34.0464 9.05751V14.0692H34.4781V17.9539H34.0464V44.1153C34.0464 46.2608 32.3072 48 30.1618 48H14.9589C12.8134 48 11.0742 46.2608 11.0742 44.1153V21.8385H10.6426V18.3855H11.0742V17.0906H10.6426V14.0692H11.0742V9.05751ZM13.3522 10.6162C13.3522 8.94749 14.705 7.59477 16.3736 7.59477H28.747C30.4157 7.59477 31.7684 8.94749 31.7684 10.6162V42.5567C31.7684 44.2254 30.4157 45.5781 28.747 45.5781H16.3736C14.705 45.5781 13.3522 44.2254 13.3522 42.5567V10.6162Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0465 19.2607V44.1154C34.0465 46.2608 32.3072 48 30.1618 48H14.9589C12.8134 48 11.0742 46.2608 11.0742 44.1154V27.7135L13.3522 27.15V42.5567C13.3522 44.2254 14.705 45.5781 16.3737 45.5781H28.747C30.4157 45.5781 31.7684 44.2254 31.7684 42.5567V19.8243L34.0465 19.2607Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3525 10.6161C13.3525 8.94745 14.7053 7.59473 16.3739 7.59473H28.7473C30.416 7.59473 31.7687 8.94745 31.7687 10.6161V42.5566C31.7687 44.2253 30.416 45.578 28.7473 45.578H16.3739C14.7053 45.578 13.3525 44.2253 13.3525 42.5566V10.6161Z",
    fill: "#F7F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7687 19.8242V42.5567C31.7687 44.2253 30.416 45.5781 28.7473 45.5781H16.3739C14.7053 45.5781 13.3525 44.2253 13.3525 42.5567V27.1499L31.7687 19.8242Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2734 -0.290315L28.7506 5.27703L34.8294 5.70061L29.262 8.17773L28.8384 14.2565L26.3613 8.68921L20.2825 8.26562L25.8498 5.7885L26.2734 -0.290315Z",
    fill: "#8E8CEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12740_18063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2212c1455e22160041f91bb2987b34d1.svg";
export { ForwardRef as ReactComponent };